define([
  'es6!sumo/util',
  'immutable',
  'underscore',
  'es6!launcher/actions/ListBuilderActions',
], (Util, Immutable, _, Actions) => {
  const initialState = Immutable.Map({
    byId: Immutable.Map(),
    byType: Immutable.Map(),
    byGroup: Immutable.Map(),
    bySlug: Immutable.Map(),
    animations: Immutable.Map(),
    isSavingMyTemplate: false,
  });

  const actionHandlers = {};

  actionHandlers[Actions.RECEIVE_TEMPLATES] = (state, action) => {
    const templatesById = action.templates;
    const templates = _.values(templatesById);
    const templatesByType = _.groupBy(templates, 'type');
    const templatesByGroup = _.groupBy(templates, 'group_id');
    // Group by slug so that popup default template count may be determined
    const templatesBySlug = _.groupBy(templates, 'slug');

    return state.merge(Immutable.fromJS({
      byId: templatesById,
      byType: templatesByType,
      byGroup: templatesByGroup,
      bySlug: templatesBySlug,
      animations: _.indexBy(action.animations, 'id'),
    }));
  };

  actionHandlers[Actions.SAVE_TEMPLATE] = (state, action) => {
    const { templateId } = action;
    const templatesById = state.get('byId');
    const updatedTemplatesById = templatesById.mergeIn([templateId], { saving: true });

    const newAction = { templates: updatedTemplatesById.toJS() };

    return actionHandlers[Actions.RECEIVE_TEMPLATES](state, newAction);
  };

  actionHandlers[Actions.SAVE_MY_TEMPLATE] = (state, action) => {
    const newTemplate = action.template;

    const newState = state.updateIn(['byId'], (templatesById) => {
      return templatesById.set(newTemplate.id, Immutable.fromJS(newTemplate));
    });

    return newState;
  };

  actionHandlers[Actions.IS_SAVING_MY_TEMPLATE] = (state, action) => {
    return state.set('isSavingMyTemplate', action.isSavingMyTemplate);
  };

  return Util.createReducer(initialState, actionHandlers);
});
